import React, { useState, useEffect } from "react";
import { Table } from "antd";

const columns = [
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "Type",
    dataIndex: "type",
  },
  {
    title: "Amount",
    dataIndex: "amount",
  },
  {
    title: "Collected On",
    dataIndex: "collectedOn",
  },
];

export default function ChargesForm({ casaDetail }) {
  const [chargeDetail, setChargeDetail] = useState([]);
  useEffect(() => {
    let tempArray = [];
    casaDetail?.charges.forEach((element) => {
      tempArray.push({
        key: element?.id,
        name: element?.name ? element?.name : "-",
        type: element?.chargeCalculationType?.value
          ? element?.chargeCalculationType?.value
          : "-",
        amount: element?.amount ? element?.amount : "-",
        collectedOn: element?.chargeTimeType?.value
          ? element?.chargeTimeType?.value
          : "-",
      });
    });
    setChargeDetail(tempArray);
  }, []);

  return (
    <Table
      columns={columns}
      dataSource={chargeDetail}
      bordered
      pagination={{
        position: "bottomCentre",
      }}
    />
  );
}
